import React from 'react';
import { X } from 'lucide-react';
export function NotForYouSection() {
  return <section className="w-full py-20 px-6 md:px-8 text-cream bg-[#6D5E85] pt-[50px] pb-[50px]" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <h2 className="md:text-4xl font-bold text-white mb-10 text-center text-[32px]" data-id="element-221">
          Para quién NO es
        </h2>

        <div className="space-y-6 mb-12" data-id="element-222">
          {['Buscas un manual médico o terapia clínica', 'Quieres consejos de crianza a largo plazo', 'Esperas un plan "perfecto" con rutinas rígidas'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white/5 p-4 rounded-xl border border-white/10 pt-[5px] pb-[5px] pl-[15px] pr-[15px]" data-id="element-223">
              <X className="w-6 h-6 text-rose-DEFAULT flex-shrink-0" data-id="element-224" />
              <span className="text-lg text-cream-light" data-id="element-225">{item}</span>
            </div>)}
        </div>

        <p className="text-center text-2xl font-serif italic text-white/90" data-id="element-226">
          "Este plan es para la vida real."
        </p>
      </div>
    </section>;
}